import Card from "components/Card";
import React from "react";

const BasePageLayout = ({ children }) => {
    return (
        <Card>
            <div className="p-3">
                {children}
            </div>
        </Card>
    )
}

export default BasePageLayout;